import {
  put, call, all, takeLatest,
} from 'redux-saga/effects';
import { notification } from 'antd';
import get from 'lodash/get';
import axiosConfig from './axiosConfig';
import { fetchCashflowListFailure, fetchCashflowListSuccess } from './action';
import { FETCH_RAW_LIST } from './types';
import NotificationEmailsAxiosConfig from '../../services/NotificationEmailsAxiosConfig';

const fetchDataPage = (tableName, pageNum, pageSize) => {
  return axiosConfig.get(`/GeProcesstList?Table_Name=${tableName}&pageNumber=${pageNum}&pageSize=${pageSize}`);
};


/** Get all raw crc pm list */
function* fetchList({ tableName, pageNumber, pageSize, searchKey, sorting }) {
  try {
    let url = `/GeProcesstList?Table_Name=${tableName}`;
    let queryParams = [];

    const isEmptyObject = (obj) => {
      return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
    };

    if (pageNumber) {
      queryParams.push(`pageNumber=${pageNumber}`);
    }

    if (pageSize) {
      queryParams.push(`pageSize=${pageSize}`);
    }

    if (searchKey && !isEmptyObject(searchKey)) {
      queryParams.push(`searchKey=${encodeURIComponent(JSON.stringify(searchKey))}`);
    }

    if (Array.isArray(sorting) && sorting.length > 0) {
      sorting.forEach(item => {
        const sortDirection = typeof item.sort === 'string' ? item.sort.toUpperCase() : '';
        queryParams.push(`${item.colId}=${sortDirection}`);
      });
    }

    // Add query parameters only if they exist
    if (queryParams.length > 0) {
      url += `&${queryParams.join('&')}`;
    }

    const res = yield axiosConfig.get(url);

    if (res.status === 200) {
      let primaryData = get(res, ['data', 'data'], []);
      const totalCount = primaryData[0]?.totalCount || 0;
      const totalPages = Math.ceil(totalCount / pageSize);

      // Fetch additional pages if available
      if (totalPages > 1) {
        const additionalDataRequests = Array.from({ length: totalPages - 1 }, (_, i) =>
          call(fetchDataPage, tableName, i + 2, pageSize)
        );
        const additionalResponses = yield all(additionalDataRequests);

        // Merge all data into a single array
        const additionalData = additionalResponses.flatMap((response) => response.data?.data || []);
        primaryData = [...primaryData, ...additionalData];
      }
      yield put(fetchCashflowListSuccess({ response: primaryData }));
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield put(fetchCashflowListFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while fetching the raw datalist.',
      description: `${error}`,
    });
  }
}



function* emeaaWatcher() {

  yield takeLatest(FETCH_RAW_LIST, fetchList);
}

function* emeaaSagas() {
  yield all([
    call(emeaaWatcher),
  ]);
}

export default emeaaSagas;




export const generateEMEAASales = async (data) => {
  try {

    const url = 'https://bbk2gmd2a2.execute-api.us-west-2.amazonaws.com/dev/generate_cash_flow'

    //const url = 'http://localhost:5000/generate_cash_flow'
    console.log('Url Data::', data)



    const res = await fetch(`${url}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        // Authorization: token
      },
      body: JSON.stringify(data),
    });

    notification.destroy();

    if (res.status === 200) {
      const rawResponse = await res.text();
      // Parse the raw text into a JSON object
      //console.log('rawResponse', rawResponse)
      let response1;
      try {
        response1 = JSON.parse(rawResponse);
      } catch (jsonError) {
        console.error("Error Parsing JSON:", jsonError);
        return null;
      }


     // console.log(response1.EMEAA_details)

      return response1.EMEAA_details
    }
    if (res.status === 403) {
      notification.error({
        message: 'A problem occurred while generate the cash flow.',
        description: `${res}`,
      });
      return null;
    }
    return null;
  } catch (error) {
    notification.error({
      message: 'A problem occurred while generate the cash flow.',
      description: `${error}`,
    });
    console.log('error', error)
    return null;
  }
};


export const GenerateCashflowExcelReport = async (data) => {
  try {


    const url = 'https://bbk2gmd2a2.execute-api.us-west-2.amazonaws.com/dev/generate_report'

    //const url = 'http://localhost:5000/generate_report'

    console.log('Url Data::', data)



    const res = await fetch(`${url}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        // Authorization: token
      },
      body: JSON.stringify(data),
    });

    notification.destroy();
    //console.log(await res.json())
    if (res.status === 200) {

      const response1 = await res.json();

      console.log(response1)

      return response1.report_url
    }
    if (res.status === 403) {
      notification.error({
        message: 'Unauthorized',
      });
      return null;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const AddOrUpdateReportUrl = async (data, isEdit = false) => {


  try {

    if (data) {
      const list = {
        'tableName': "Project_Details",
        data: [data],
        isEdit: isEdit
      }
      const res = await axiosConfig.post('/AddOrUpdate', list);



      notification.destroy();
      // console.log(yield res.json)
      if (res.status === 200) {
        const responseData = get(res, ['data', 'data'], {});
        notification.success({
          message: 'Report Generated Successfully.',
          duration: 3,
        });
        // await fetchRecordList()
        return responseData

      }

      else {

        notification.error({
          message: 'Something went wrong.',
        });
        return null

      }
    }

  } catch (error) {

    notification.destroy();
    notification.error({
      message: 'Update Submission Failed.',
      description: `${error}`,
    });
    return null

  }
}
export const AddOrUpdateMasterData = async (data, isNotify = true) => {


  try {
    const res = await axiosConfig.post('/AddOrUpdataConfig', data);

    notification.destroy();
    // console.log(yield res.json)
    if (res.status === 200) {
      const responseData = get(res, ['data', 'data'], {});
      if (isNotify)
        notification.success({
          message: 'Added Successfully.',
          duration: 3,
        });

      return responseData

    }

    else {

      notification.error({
        message: 'Something went wrong.',
      });
      return []

    }


  } catch (error) {

    notification.destroy();
    notification.error({
      message: 'Update Submission Failed.',
      description: `${error}`,
    });
    return null

  }
}


export const AddOrUpdateCashFlowProject = async (data, isEdit = false, isSendMaill = false) => {

  try {

    if (data) {

      const list = {
        'tableName': "Project_Details",
        data: [data],
        isEdit: isEdit
      }
      const res = await axiosConfig.post('/AddOrUpdate', list);

      notification.destroy();
      // console.log(yield res.json)
      if (res.status === 200) {
        const responseData = get(res, ['data', 'data'], {});
        notification.success({
          message: isEdit ? 'Updated Successfully.' : 'CashFlow Generated Successfully.',
          duration: 3,
        });

        const stage = process.env.REACT_APP_STAGE
        if (stage == 'prod') 
        {
          const user = JSON.parse(localStorage.getItem("user"));
          let sub = "EMEAA cash flow generated by " + user.name
          let Title = "Spare parts generation notification"
          if (isEdit) {
            sub = "EMEAA cash flow modified by " + user?.name ||''
            Title = "EMEAA cash flow updated notification"
          }
       
          const emailData = {
            TitleContent: Title,
            Subject: sub,

            data: {
              "Project Name": data.Name,
              "Country": data.Country,
              "Pipelines count":data.Pipelines_count,
              "Expected signing date": data.Expected_signing_date,
              "Production start":data.Production_start,
              "Production end": data.Production_end,
              "Start of job":data.Start_of_job,
              "Leaves port": data.Leaves_port,
              "Arrives port":data.Arrives_port,
              "welding wire order": data.welding_wire_order,
              "Welding wire shipment": data.Welding_wire_shipment,
              "Payment terms": data.Payment_terms,
              "Commission": data.Commission,
            }
          }
          await NotificationEmailsAxiosConfig.post(`NotifyEmails`, emailData);
        }


        return responseData

      }

      else {

        notification.error({
          message: 'Something went wrong.',
        });
        return null

      }
    }

  } catch (error) {

    notification.destroy();
    notification.error({
      message: 'Update Submission Failed.',
      description: `${error}`,
    });
    return null

  }
}


export const AddOrUpdateInputProject = async (data, isEdit = true, isSendMaill = false) => {


  try {

    if (data) {

      const list = {
        'tableName': "Project_Inputs",
        data: [data],
        isEdit: isEdit
      }
      const res = await axiosConfig.post('/AddOrUpdate', list);

      notification.destroy();
      // console.log(yield res.json)
      if (res.status === 200) {
        const responseData = get(res, ['data', 'data'], {});
        notification.success({
          message: data.isEdit || isEdit ? 'Update Successfully.' : 'Added Successfully.',
          duration: 3,
        });

        return responseData

      }

      else {

        notification.error({
          message: 'Something went wrong.',
        });
        return null

      }
    }

  } catch (error) {

    notification.destroy();
    notification.error({
      message: 'Update Submission Failed.',
      description: `${error}`,
    });
    return null

  }
}

export const DeleteDetails = async (data) => {

  try {
    const resmaster = await axiosConfig.post('/Delete', data);
    //console.log(resmaster)
    if (resmaster.status === 200) {
      notification.success({
        message: 'Deleted Successfully.',
        duration: 3,
      });
      return true
    }
    else {

      notification.error({
        message: 'Something went wrong.',
      });
      return false
    }


  } catch (error) {

    notification.destroy();
    notification.error({
      message: 'Delete Submission Failed.',
      description: `${error}`,
    });
    return false

  }
}


export const ShareReport = async (data) => {

  try {
    const resmaster = await axiosConfig.post('/ShareReport', data);
    //console.log(resmaster)
    if (resmaster.status === 200) {
      notification.success({
        message: 'File will be sent to your e-mail shortly!',
        duration: 3,
      });
      return true
    }
    else {

      notification.error({
        message: 'Something went wrong.',
      });
      return false
    }


  } catch (error) {

    notification.destroy();
    notification.error({
      message: 'Share Submission Failed.',
      description: `${error}`,
    });
    return false

  }
}


export const getListFromDatabase = async (tableName) => {
  try {
    let url;
    url = `/GetList?Table_Name=${(tableName)}`;


    const res = await axiosConfig.get(url);
    if (res.status === 403) {
      notification.error({
        message: 'Unauthorized',
      });
      return null;
    } if (res.status === 200) {
      const data = get(res, ['data', 'data'], {});
      //console.log('testType', data)
      return data;
    }
    return [];
  } catch (error) {
    return [];
  }
};